import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../utils/propUtils';
import VeltCommentDialogSuggestionMenuContentItemIconWireframe from './VeltCommentDialogSuggestionMenuContentItemIconWireframe/VeltCommentDialogSuggestionMenuContentItemIconWireframe';
import VeltCommentDialogSuggestionMenuContentItemLabelWireframe from './VeltCommentDialogSuggestionMenuContentItemLabelWireframe/VeltCommentDialogSuggestionMenuContentItemLabelWireframe';
var VeltCommentDialogSuggestionMenuContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-menu-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionMenuContentItemWireframe.Icon = VeltCommentDialogSuggestionMenuContentItemIconWireframe;
VeltCommentDialogSuggestionMenuContentItemWireframe.Label = VeltCommentDialogSuggestionMenuContentItemLabelWireframe;
export default VeltCommentDialogSuggestionMenuContentItemWireframe;
